import React from 'react'

function AccountDetail() {
  return (
    <div>
      
    </div>
  )
}

export default AccountDetail
